export namespace IDialog {

  export enum Events {
    TRANSITION_TO_ORDER = 'transition-to-order-dialog:open',
    DOWNLOAD_EXCEL = 'excel-download-dialog:open',
    CAR_POPUP_CHANGE_DISPLAY = 'car-popup:change-display',
    CAR_POPUP_UPDATE_MOVEMENTS = 'car-popup:update-movements',
  }

  export interface PopupData {
    blockName: string;
    dialogName: string;
    payload?: any;
    savePayload?: boolean;
    secondaryPopup?: boolean;
  }

  export interface IActivePopup {
    blockName: string;
    dialogName: string;
  }
}


export interface IDialogStoreState {
  activePopup: IDialog.IActivePopup;
  stackPopup: IDialog.IActivePopup[];
  auth: {
    loginSelectCorp: boolean;
  };
  carList: {
    uploadCrsExcel: boolean;
  };
  car: {
    confirmArchive: boolean;
  },
  registration: {
    ofertaPopup: boolean;
  };
  profile: {
    changePasswordPopup: boolean;
    changeEmailPopup: boolean;
    accountLogPopup: boolean;
    accountPopup: boolean;
  };
  reports: {
    reportMovementsChange: boolean;
    selectMovementPopup: boolean;
  };
  barriers: {
    openBarrier: boolean;
    demoMoves: boolean;
    barrierLog: boolean;
    trailerPopup: boolean;
    similarNumbers: boolean;
  };
  home: {
    favoriteCars: boolean;
    getAccess: boolean;
    installAppInstruction: boolean;
  };
  parksConfig: {
    parkEvents: boolean;
    parkEventsLog: boolean;
  };
  payment: {
    balancePopup: boolean;
    payByCardPopup: boolean;
    bankAccountDocument: boolean;
    bankIframePopup: boolean;
    cantExitPopup: boolean;
    claimsPopup: boolean;
  },
  allPages: {
    feedbackPopup: boolean;
    antiTheftCars: boolean;
    eventsLog: boolean;
    appMediaPopup: boolean;
    cashPayPopup: boolean;
    decodeMoneyPopup: boolean;
    inputCarNumber: boolean;
    deviceStatsPopup: boolean;
    corpPopup: boolean;
    cookieBannerPopup: boolean;
  };
  payload: any;
  updatePopup: boolean;
}
